export default "__VITE_ASSET__37590999__"